import React from "react";
import { useConnectionStatus } from "./hooks/useConnectionStatus";
import "./app-bottom.css";

type Props = {
  hideConnected?: boolean;
};

const AppBottom: React.FunctionComponent<Props> = React.memo(({ hideConnected }) => {
  const { connectionStatus, statusText, indicatorClass } =
    useConnectionStatus();
  const className =
    "min-h-4 px-2 flex justify-center items-center text-base bg-night-primary border-black border-2 border-t-0 text-center leading-none shadow-aestheticBottom";
  return (
    <div className="hidden z-50 md:flex flex-row-reverse justify-between mx-4 h-5">
      {connectionStatus !== undefined ? (
        <div className={hideConnected ? `${className} hidden` : className}>
          <span className={`status-indicator ${indicatorClass}`}></span>
          <span className="ml-2">{statusText}</span>
        </div>
      ) : null}

      {/* {leftLabel && (
                <div className="app-bottom-label">
                    {leftLabel}
                </div>
            )} */}
    </div>
  );
});

export default AppBottom;
